import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { formatRestaurantNote, GoldStar } from "../../../../components/containerRestau/hookContainerRestau";
import { buildRestaurantTypeLabel } from "../../../../components/types/restaurantTypes";
import {  slugify } from "../../../../components/types/types";
import { MultiSearchResult } from "../hookSearchPage";
import './ResultMultiSearchPopup.css'

interface ContainerResultSearchProps {
    multiSearchResults:MultiSearchResult[];
}

const ContainerResultSearch:React.FC<ContainerResultSearchProps> = ({multiSearchResults}) => {


    return <div className="containerListMultiSearch">
        {
        multiSearchResults.length === 0 ? <>
            <span className="XsmallText" style={{marginTop:'1em',marginBottom:'2em',display:'block'}}>Aucun résultat correspondant</span>
            <div className="separationNoResult"></div>
            </>
        : multiSearchResults.map((elem,id) => {
            const elemResto = elem.kind !== 'restaurant' ? null : elem.restaurant
            const linkResto = !elemResto ? '' : `/restaurant/${slugify(elemResto.address[1])}/${slugify(elemResto.name)}_${elemResto.id_url}?src=home`
            const key = `${elem.kind}-${elem.label}-${id}`;

            return <React.Fragment key={key}>
            {(elem.kind === 'restaurant') && <Link to={linkResto} state={{ skipSplash: true }} target="_blank" rel="noopener" className="elemSearch pointer lowOpacityHover">
                <div className="containerImg"><img src={elem.restaurant.devanture} loading="lazy"/></div>
                <div className="mainPart">
                    <span className="name midTextBold">{elem.restaurant.name}</span>
                    <span className="type XsmallText">{elem.restaurant.type_display || buildRestaurantTypeLabel(elem.restaurant.type)}</span>
                    <span className={`note ${formatRestaurantNote(elem.restaurant.note) ? '' : 'rateHidden'}`} >{elem.restaurant.note} <GoldStar id={elem.restaurant.idrestaurant} className="star" size={17}/></span>
                </div>
                <FiChevronRight size={18} className="iconChevron" />
            </Link>}
            {id < multiSearchResults.length -1 && <div className="separationMultiSearch"></div>}
            </React.Fragment>
        })
    }</div>
}

export default ContainerResultSearch;